import { WebLog_Log_List, WebLog_WebLog_List, Use_Confirm_List, Use_Cancel_List, Emission_List } from './../../models/voucherCouponMg.model';
import { MessageService } from 'primeng/api';
import { Injectable } from '@angular/core';
import { Context, VoucherCouponList, VoucherCouponDetail, WebLog_Log } from 'app/models/voucherCouponMg.model';
import 'rxjs/Rx';
import { Observable } from 'rxjs/Rx';
import { HttpClientService } from '../httpClient/httpclient.service';

@Injectable()
export class VoucherCouponService {

  baseUrl_Management = HttpClientService.BASE_MS_COUPON_MG_MANAGEMENT;
  baseUrl_Log = HttpClientService.BASE_MS_COUPON_MG_LOG;
  defaultItemPerPage = HttpClientService.DEFAULT_ITEM_PER_PAGE;

  constructor (
    private h: HttpClientService,
    private srvNotify: MessageService  
  ) { }
  list(filters?: Array<{key: string, value: any}>,page?: number, itemPerPage?: number, orderBy?: Array<{type: string, key: string}>): Observable<VoucherCouponList>{        
    let body = {};
    
    if(filters && filters.length > 0){
      for(let filter of filters){        

        if(filter.key == "value"){
          body[filter.key] = +filter.value;
        }
        else{
          body[filter.key] = filter.value;        
        }          
      }
    }    

    body["pagination"] = {
      page: page ? page: 0,
      itemPerPage: itemPerPage ?  itemPerPage : this.defaultItemPerPage
    }    
    
    if(orderBy && orderBy.length>0){
      body["orderBy"] = Object.assign([],orderBy);
    }

    return this.h.post_KSS(this.baseUrl_Management + "/list", body);
  }
  editVoucherCoupon(footprint: string,eanCode: string, voucherId: string, printed: boolean,stateCode: string): Observable<any>{

    let body = {
      footprint: footprint,
      eanCode: eanCode,
      voucherId: voucherId,
      printed: printed,
      stateCode: stateCode
    }
    return this.h.patch_KSS(this.baseUrl_Management + "/voucher", body).map(res => {
      if(res){
        this.srvNotify.add({severity: 'success', summary: 'Success', detail: 'Operation success'});
        return res;
      }        
    });;
  }  
  getDetails(voucherId: string,eanCode: string, footprint: string): Observable<VoucherCouponDetail>{
    let body = {
      footprint: footprint,      
      eanCode: eanCode,
      voucherId: voucherId
    };
    return this.h.post_KSS(this.baseUrl_Management + "/voucher-detail", body,null);
  }  
  getContext(): Observable<Context>{          
    /* utilizzato per prendere la lista di tutti i dati statici che mi servono: 
    lista canali, lista eanvalue, lista tipi voucher, lista stati voucher, lista negozi, lista tipi issue
    */
    return this.h.get_KSS(this.baseUrl_Management+"/context");
  }
  getWebLog_Log(filters?: Array<{key: string, value: any}>,page?: number, itemPerPage?: number): Observable<WebLog_Log_List>{

    let body = {};

    if(filters && filters.length > 0){
      for(let filter of filters){        
        body[filter.key] = filter.value;        
      }
    }    
    
    body["pagination"] = {
      page: page ? page: 0,
      itemPerPage: itemPerPage ?  itemPerPage : this.defaultItemPerPage
    }    

    return this.h.post_KSS(this.baseUrl_Log + "/log/log", body,null);
  }
  getWebLog_WebLog(filters?: Array<{key: string, value: any}>,page?: number, itemPerPage?: number): Observable<WebLog_WebLog_List>{

    let body = {};

    if(filters && filters.length > 0){
      for(let filter of filters){        
        body[filter.key] = filter.value;
      }
    }    
    
    body["pagination"] = {
      page: page ? page: 0,
      itemPerPage: itemPerPage ?  itemPerPage : this.defaultItemPerPage
    }    

    return this.h.post_KSS(this.baseUrl_Log + "/log/web-log", body,null);
  }
  getUse(filters?: Array<{key: string, value: any}>,page?: number, itemPerPage?: number): Observable<WebLog_WebLog_List>{

    let body = {};

    if(filters && filters.length > 0){
      for(let filter of filters){        
        body[filter.key] = filter.value;
      }
    }    
    
    body["pagination"] = {
      page: page ? page: 0,
      itemPerPage: itemPerPage ?  itemPerPage : this.defaultItemPerPage
    }    

    return this.h.post_KSS(this.baseUrl_Log + "/operation/redeem", body,null);
  }
  getUse_Confirm(filters?: Array<{key: string, value: any}>,page?: number, itemPerPage?: number): Observable<Use_Confirm_List>{

    let body = {};

    if(filters && filters.length > 0){
      for(let filter of filters){        
        body[filter.key] = filter.value;
      }
    }    
    
    body["pagination"] = {
      page: page ? page: 0,
      itemPerPage: itemPerPage ?  itemPerPage : this.defaultItemPerPage
    }    

    return this.h.post_KSS(this.baseUrl_Log + "/operation/confirm", body,null);
  }
  getUse_Cancel(filters?: Array<{key: string, value: any}>,page?: number, itemPerPage?: number): Observable<Use_Cancel_List>{

    let body = {};

    if(filters && filters.length > 0){
      for(let filter of filters){        
        body[filter.key] = filter.value;
      }
    }    
    
    body["pagination"] = {
      page: page ? page: 0,
      itemPerPage: itemPerPage ?  itemPerPage : this.defaultItemPerPage
    }    

    return this.h.post_KSS(this.baseUrl_Log + "/operation/abort", body,null);
  }
  getEmission(filters?: Array<{key: string, value: any}>,page?: number, itemPerPage?: number): Observable<Emission_List>{

    let body = {};

    if(filters && filters.length > 0){
      for(let filter of filters){        
        body[filter.key] = filter.value;
      }
    }    
    
    body["pagination"] = {
      page: page ? page: 0,
      itemPerPage: itemPerPage ?  itemPerPage : this.defaultItemPerPage
    }    

    return this.h.post_KSS(this.baseUrl_Log + "/operation/add", body,null);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/voucher-coupon-mg/voucher-coupon.service.ts